module.exports = __webpack_public_path__ + "img/event-surprising-facts-armenia.6d81386f.webp";